import React from 'react';
import ReactDOM from 'react-dom';
import './popupgenerico.css'; // Asegúrate de importar los estilos

const PopupGenerico = ({ onClose, content }) => {
    return ReactDOM.createPortal(
        <div className="popup_overlay_generico" onClick={onClose}>
            <div className="popup_content" onClick={e => e.stopPropagation()}>
                <button className="close_btn" onClick={onClose}>×</button>
                {content}
            </div>
            
        </div>,
        document.body
    );
};

export default PopupGenerico;